import React from 'react';
import * as FaIcons from "react-icons/fa";
import './ActionButton.css';
import PropTypes from 'prop-types';

const ActionButton = ({
    icon,
    label,
    onClick,
    variant = "secondary",
    disabled = false,
    className = ""
}) => {
    const Icon = FaIcons[icon];

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`btn btn-sm btn-${variant} d-flex align-items-center gap-2 custom-action-btn ${className}`}
        >
            {Icon && <Icon size={14} />}
            {label && <span>{label}</span>}
        </button>
    );
};

ActionButton.propTypes = {
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string
};
export default ActionButton;